/**
 * Thin wrapper around the shared {@link EventForm} (variant 'sidebar'): the create/edit form
 * of the calendar event sidebar, ported onto the drawer surface (EventSidebar hosts it).
 * All behavior - the draft state, validation, the PATCH create/edit semantics, the color
 * palette, the conflict watch and the delete gate - lives in EventForm; this module keeps the
 * sidebar's public surface (props, the prefill type, `zeroInitial`) stable for EventSidebar,
 * CalendarPage and the tests.
 */

import type { JSX } from 'react';

import { EventForm } from './EventForm';
import type { EventSidebarFormProps } from './EventForm';

export type { EventSidebarFormProps, EventSidebarInitial } from './EventForm';
export { zeroInitial } from './EventForm';

export function EventSidebarForm({
  token,
  initial = undefined,
  event = null,
  allEvents = [],
  onSaved,
  onDeleted,
  onClose,
  onCancel,
}: EventSidebarFormProps): JSX.Element {
  return (
    <EventForm
      variant="sidebar"
      token={token}
      initial={initial}
      event={event}
      allEvents={allEvents}
      onSaved={onSaved}
      onDeleted={onDeleted}
      onClose={onClose}
      onCancel={onCancel}
    />
  );
}
